import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import changeReducerFactory from './factories/changeReducerFactory';
import detailReducerFactory from './factories/detailReducerFactory';
import entityReducerFactory from './factories/entityReducerFactory';
import applyReducer from './applyReducer';
import pickerConstants from '../constants/pickerConstants';
const entityReducer = entityReducerFactory('picker');
const changeReducer = changeReducerFactory('picker');
const detailReducer = detailReducerFactory('picker');
const defaultIndexQuery = _objectSpread(_objectSpread({}, entityReducer.initState.indexQuery), {}, {
  paging: null,
  filters: {
    text: ''
  }
});
const initState = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, entityReducer.initState), changeReducer.initState), detailReducer.initState), {}, {
  indexQuery: defaultIndexQuery,
  initialIndexQuery: defaultIndexQuery
});
const serverSaveAllSuccess = (state, _ref) => {
  let data = _ref.data;
  return _objectSpread(_objectSpread({}, state), {}, {
    list: data
  });
};
const serverSave = state => _objectSpread(_objectSpread({}, state), {}, {
  list: []
});
const reducers = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, changeReducer.reducers), detailReducer.reducers), entityReducer.reducers), {}, {
  [pickerConstants.SAVE_ALL_SUCCESS]: serverSaveAllSuccess,
  [pickerConstants.SERVER_SAVE]: serverSave
});
export default applyReducer(reducers, initState);